<!-- Annual Report Hero Section -->
<div class="annual-hero-bg">
    <section class="annual-hero-section container">
        <div class="glass-panel-container">
            <div class="row align-items-center">

                <div class="col-lg-5 hero-content-col">
                    <h1 class="banner-heading-one">Kalpita Annual Reports</h1>
                </div>

                <div class="col-lg-7 hero-image-col">
                    <img src="../../../../assets/annual-report/annual-report-heroimage.png"
                        alt="Annual Reports Illustration" class="hero-image">
                </div>
            </div>
        </div>
    </section>
</div>

<!-- Annual Report List Section -->
<div class="container">
    <div class="row py-5 mb-5">
        <h2 class="pb-3 fw-bold">READ OUR ANNUAL REPORTS</h2>
        <div class="col-md-4 py-2" *ngFor="let ar of annualreport">
            <div class="card p-3">
                <div class="row ">
                    <a [href]="ar.url" download class="d-flex link-url">
                        <div class="col-10 col-md-10 ">
                            <h6 class="mb-0 title-text">{{ar.title}} </h6>
                        </div>
                        <div class="col-2 col-md-2 d-flex justify-content-end"><span class=""><i
                                    class="ri-download-2-line download-ico"></i></span></div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>